import { getEnglishCaseStudyBySlug } from "@/app/seo-case-studies-en";
import { CaseStudyLayout } from "./CaseStudyLayout";

export default function CallerTeamLocalLoopCaseStudy() {
  const study = getEnglishCaseStudyBySlug("caller-team-local-loop");
  if (!study) return null;
  return <CaseStudyLayout study={study} />;
}
